import styled, { css } from 'styled-components';
import { Element as WhitePaperElement } from '@/components/elevation/WhitePaper/WhitePaper.styles';
import { helperTextUtility, inputBaseUtility, validationPseudoClassUtility } from '@/styles/utilities';

export const KroozeFormContainer = styled(WhitePaperElement)`
  ${({ theme }) => {
    return css`
      margin-top: -3rem;
      #kzsearch {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        min-height: 3.8rem; // hack to fix layout shift

        @media screen and (min-width: ${theme.breakpoint.sm}) {
          flex-direction: row;
        }

        div[class*='form-group'] {
          display: flex;
          flex-grow: 1;
          flex-direction: column;
          align-content: center;

          label {
            display: block;
            font-size: ${theme.typography.font_size.text_sm};
            font-weight: ${theme.typography.font_weight.text_bold};
          }

          select {
            // Base Style
            ${inputBaseUtility};

            // NOTE: CaretDownIcon content injected here as string
            background-image: url('data:image/svg+xml;utf8,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3538 6.35403L8.35375 11.354C8.30732 11.4005 8.25217 11.4374 8.19147 11.4626C8.13077 11.4877 8.06571 11.5007 8 11.5007C7.9343 11.5007 7.86923 11.4877 7.80853 11.4626C7.74783 11.4374 7.69269 11.4005 7.64625 11.354L2.64625 6.35403C2.55243 6.26021 2.49973 6.13296 2.49973 6.00028C2.49973 5.8676 2.55243 5.74035 2.64625 5.64653C2.74007 5.55271 2.86732 5.5 3 5.5C3.13269 5.5 3.25993 5.55271 3.35375 5.64653L8 10.2934L12.6463 5.64653C12.6927 5.60007 12.7479 5.56322 12.8086 5.53808C12.8693 5.51294 12.9343 5.5 13 5.5C13.0657 5.5 13.1308 5.51294 13.1915 5.53808C13.2521 5.56322 13.3073 5.60007 13.3538 5.64653C13.4002 5.69298 13.4371 5.74813 13.4622 5.80883C13.4873 5.86953 13.5003 5.93458 13.5003 6.00028C13.5003 6.06598 13.4873 6.13103 13.4622 6.19173C13.4371 6.25242 13.4002 6.30757 13.3538 6.35403Z" fill="black"/></svg>');
            background-repeat: no-repeat;
            background-position: right 0.5rem center;

            // Sizing
            max-height: 40px;

            ${validationPseudoClassUtility};
            ${helperTextUtility};
          }

          + button {
            // Base style
            &,
            &[type='button'],
            &[type='reset'],
            &[type='submit'] {
              -webkit-appearance: button;

              &:not(:disabled) {
                cursor: pointer;
              }
            }

            vertical-align: middle;
            user-select: none;
            margin-block-start: 0;
            margin-block-end: 0;
            padding-block-start: 0;
            padding-block-end: 0;

            font-size: ${theme.typography.font_size.text_base};
            font-weight: ${theme.typography.font_weight.text_bold};
            padding: ${theme.spacing.sm} ${theme.spacing.base};
            text-align: center;

            // Style
            color: ${theme.color.white};
            border-color: ${theme.color.neutral_400};
            border-radius: ${theme.radius.xs};
            outline: 0;

            // Transition
            transition: ${theme.transition.all};

            // Appearance
            background: ${theme.color.secondary_500};

            // States (default)
            &:hover {
              background: ${theme.color.secondary_800};
              color: ${theme.color.white};
            }
            &:focus {
              background: ${theme.color.secondary_600};
              border-color: ${theme.color.secondary_600};
              box-shadow: ${theme.box_shadow.sm};
            }
            &:active {
              background: ${theme.color.secondary_800};
            }
            &:disabled {
              background: ${theme.color.secondary_500};
            }

            height: 40px;
            place-self: end;
          }
        } // div[class*='form-group']

        // Custom style
        div[class*='form-group'] {
          //padding-left: 1rem;
        }
      }
    `;
  }}
`;

export const FlexContainer = styled.div`
  ${({ theme }) => {
    return css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: ${theme.spacing.base};

      @media screen and (min-width: ${theme.breakpoint.sm}) {
        flex-direction: row;
      }
    `;
  }};
`;

export const MapContainer = styled.div`
  ${({ theme }) => {
    return css`
      width: 100%;
      overflow-x: scroll;
    `;
  }};
`;

export const MapImageContainer = styled.div`
  ${({ theme }) => {
    return css`
      position: relative;
      width: 1004px;
      margin: 0 auto;
      //display: flex;
      @media screen and (min-width: ${theme.breakpoint.sm}) {
        justify-content: center;
      }
      > svg {
        flex-shrink: 0;
        height: 653px;
        max-height: 80vh;
        min-height: 653px;
      }

      > div {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        bottom: 0;
        //border: 2px dotted green;

        // *****
        display: grid;
        grid-template-rows: repeat(auto-fill, minmax(50px, 50px));
        grid-template-columns: repeat(auto-fill, minmax(50px, 50px));
        //grid-auto-flow: column;
        // *****
      }
    `;
  }};
`;

export const MapRegionCell = styled.div<{ coordinates?: { x: number; y: number } | null }>`
  ${({ theme, coordinates }) => {
    return css`
      ${(coordinates &&
        css`
          grid-column-start: ${coordinates.y};
          grid-row-start: ${coordinates.x};
        `) ||
      css`
        display: none;
      `}

      // position content item in the middle of the grid cell
      margin-left: 50%;
      margin-top: 25%;

      a {
        display: inline-flex;
        align-items: center;
        //text-wrap: nowrap;

        > svg {
          flex-shrink: 0;
        }

        > p {
          padding: 0.11rem 0.25rem;
        }

        // -------------------------------
        // Stylish region name component
        // -------------------------------

        border: 1px solid ${theme.color.neutral_400};
        border-radius: ${theme.radius.xs};
        background: white;
        overflow: hidden;
        box-shadow: ${theme.box_shadow.default};

        &:hover {
          background: ${theme.color.info_100};
        }

        > svg {
          background: ${theme.color.primary_200};
          //border-radius: 0.25rem 0 0 0.25rem;
          flex-grow: 1;
        }

        > p,
        span {
          text-wrap: nowrap;
          display: flex;

          &.break {
            text-wrap: wrap;
            min-width: 18rem;
          }

          > small {
            display: inline;
            margin-left: 0.25rem;
            align-self: center;
            text-transform: uppercase;
          }
        }
      }
    `;
  }};
`;

export const CompanyLogoContainer = styled.div`
  ${({ theme }) => {
    return css`
      display: grid;
      align-items: center;
      justify-items: stretch;
      grid-template-columns: repeat(2, 1fr);
      gap: 1rem;

      @media screen and (min-width: ${theme.breakpoint.sm}) {
        grid-template-columns: repeat(6, 1fr);
      }
      > div {
        align-self: stretch;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        min-height: 12rem;
        padding: 0;
        a {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          align-self: stretch;
          padding: 2rem;
        }
      }
    `;
  }}
`;
